import React, { useMemo, useState } from 'react';
import Modal from 'react-modal';
import { useAxios } from '../../../hooks/useAxios/useAxios';
import { toast } from 'react-toastify';
import isEqualObjValues from '../../../pages/utils/isEqualObjValues';

Modal.setAppElement('#__next');

const customStyles = {
  content: {
    position: 'relative',
    maxWidth: '800px',
    width: '100%',
    padding: '3rem',
    marginLeft: '2rem',
    marginRight: '2rem',
    overflow: 'hidden auto',
    boxShadow: '0 10px 25px rgba(0,0,0,0.5)',
    maxHeight: 'calc( 100vh - 4rem )',
    fontSize: '16px'
  }
};

export const useAdrValidation = () => {
  const [modalData, setModalData] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);

  const { execute: validate } = useAxios(
    '/public/buyontrust/address_validation',
    {
      method: 'post'
    },
    false
  );

  const validateAdr = async reqConfig => {
    try {
      const resp = await validate(reqConfig);
      setModalData(resp);
      const isCorrectAdr = isEqualObjValues(
        reqConfig.address,
        resp?.addressValidated
      );

      if (!reqConfig.isValid && isCorrectAdr) {
        return true;
      } else {
        setIsModalOpen(true);
      }
    } catch (e) {
      toast.error(e.message);
    }
  };

  function closeModal() {
    setIsModalOpen(false);

    setTimeout(() => {
      setModalData(null);
    }, 350);
  }

  const ValidModal = useMemo(() => {
    return ({ children }) => (
      <Modal
        isOpen={isModalOpen}
        onRequestClose={closeModal}
        className="valid-modal-mobile product-single-container product-single-default product-quick-view custom-scrollbar mb-0"
        overlayClassName="ajax-overlay open-modal"
        closeTimeoutMS={100}
        style={customStyles}>
        {children}
        <button
          title="Close (Esc)"
          type="button"
          className="mfp-close"
          onClick={closeModal}>
          ×
        </button>
      </Modal>
    );
  }, [isModalOpen]);

  return [ValidModal, modalData, closeModal, validateAdr];
};
